import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { Status } from "@app/shared/enums";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { LocaleDateTime } from "@app/shared/pipes/locale-date-time";
import { TrimLeadingZero } from "@app/shared/pipes/trim-leading-zero";
import { SubRegion } from "@app/shared/classes/subRegion";
import { CommonFieldLabel, CommonFieldName } from "@app/shared/constants";
import { DynamicTranslate } from "@app/shared/pipes/dynamic-translate";
import { GenerateKpiDropDownItems, Kpi } from "@app/shared/classes/kpi";

export enum SafetyFieldName {
  driverName = "driverName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  kpiName = "kpiName",
  kpi_Translation_Id = "kpi_Translation_Id",

  emIncidentNumber = "emIncidentNumber",
  emIncidentStartTime = "emIncidentStartTime",
  emIncidentTitle = "emIncidentTitle",
  emIncidentURL = "emIncidentURL",
  status = "status",
  kpiSaftyComment = "kpiSaftyComment",
  created_On = "created_On",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  apexId = "apexId",
  fullName = "fullName",
  errorMessage = "errorMessage"
};

enum FieldLabel {
  DRIVER_NAME = "ml_143908",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  KPI_NAME = "ml_143913",

  EM_INCIDENT_NUMBER = "ml_144061",
  EM_INCIDENT_START_TIME = "ml_144085",
  EM_INCIDENT_TITLE = "ml_144086",
  EM_INCIDENT_URL = "ml_144087",
  INACTIVE = "ml_144081",
  COMMENT = "ml_151203",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  DRIVER_APEX_ID = "ml_143930",

  IMPORT_FAILED_MESSAGE = "ml_143954"
}

const SafetySearchByList: SearchByItem[] = [
  { searchBy: SafetyFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: SafetyFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: SafetyFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: SafetyFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: SafetyFieldName.kpiName, searchByLabel: FieldLabel.KPI_NAME, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: SafetyFieldName.emIncidentStartTime, searchByLabel: FieldLabel.EM_INCIDENT_START_TIME, searchByType: smartSearchType.dateRangeSelct
  },
  { searchBy: SafetyFieldName.emIncidentNumber, searchByLabel: FieldLabel.EM_INCIDENT_NUMBER },
  { searchBy: SafetyFieldName.emIncidentTitle, searchByLabel: FieldLabel.EM_INCIDENT_TITLE },
  {
    searchBy: SafetyFieldName.status, searchByLabel: FieldLabel.INACTIVE, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: [{ value: Status.INACTIVE, label: "ml_143931" }, { value: Status.ACTIVE, label: "ml_143932" }]
  },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_NAME,
    name: SafetyFieldName.driverName,
    sort: true,
    sortFieldName: SafetyFieldName.fullName
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: SafetyFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: SafetyFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: SafetyFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: SafetyFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.KPI_NAME,
    name: SafetyFieldName.kpi_Translation_Id,
    sort: true,
    pipe: DynamicTranslate
  },
  {
    text: FieldLabel.EM_INCIDENT_NUMBER,
    name: SafetyFieldName.emIncidentNumber,
    sort: true,
    pipe: TrimLeadingZero
  },
  {
    text: FieldLabel.EM_INCIDENT_START_TIME,
    name: SafetyFieldName.emIncidentStartTime,
    sort: true,
    pipe: LocaleDateTime
  },
  {
    text: FieldLabel.EM_INCIDENT_TITLE,
    name: SafetyFieldName.emIncidentTitle,
    sort: true
  },
  {
    text: FieldLabel.EM_INCIDENT_URL,
    name: SafetyFieldName.emIncidentURL,
  },
  {
    text: FieldLabel.INACTIVE,
    name: SafetyFieldName.status,
    sort: true
  },
  {
    text: FieldLabel.COMMENT,
    name: SafetyFieldName.kpiSaftyComment,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: SafetyFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: SafetyFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: SafetyFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
];

export const GetSafetySearchByList = ([terminals, subRegions, kpis, userCountry]: [DropDownItem[], SubRegion[], Kpi[], string]) => {
  var result = SafetySearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  result[4].searchDropDownValue = GenerateKpiDropDownItems(
    kpis.filter(kpi => kpi && kpi.kpiConfigurations && kpi.kpiConfigurations.filter(config => config && config.country === userCountry).length > 0));
  return result;
}
